<div class="global-action-block" *ngIf="showLoader">
  <!-- Blocks the user from doing any action while any HTTP load is in progress -->
</div>

<div class="global-loader" *ngIf="showLoader">
  <i class="fas fa-sync fa-spin"></i>
  <div class="d-inline-block ml-3">Loading</div>
</div>
